import http from "@seims/shared/src/services/HttpService";

const endpoint = `/data-migration/`;

const uploadFile = async (file, module, onUploadProgress) => {
  const formData = new FormData();
  formData.append("file", file);

  const response = await http.post(`${endpoint}${module}/upload`, formData, {
    onUploadProgress: (progress) =>
      onUploadProgress(progress.loaded / progress.total),
  });
  return response;
};

const getRecordLimit = async (module) => {
  const response = await http.get(`${endpoint}${module}/upload/record-limit`);
  return response;
}
const getUploadHistory = async (module) => {
  const response = await http.get(`${endpoint}${module}/history`, {
    responseType: "arraybuffer",
  });
  return response;
};

const getUploadOwnHistory = async (module, own) => {
  const response = await http.get(`${endpoint}${module}/upload/history?own=${own}`);
  return response;
}

const getColumnHeaders = async (module) => {
  const response = await http.get(`${endpoint}${module}/headers`);
  return response;
}

const downloadOriginalFile = async (fileUuid,module) => {
  const response = await http.get(`${endpoint}${module}/upload/original-file/${fileUuid}`, {responseType: "arraybuffer"});
  return response;
}

const downloadReport = async (reportUuid,module) => {
  const response = await http.get(`${endpoint}${module}/upload/report/${reportUuid}`);
  return response;
};

const downloadOverviewReport = async (reportUuid,module) => {
  const response = await http.get(`${endpoint}${module}/upload/overview/${reportUuid}`);
  return response;
};

export default {
  uploadFile,
  getUploadHistory,
  getUploadOwnHistory,
  getColumnHeaders,
  downloadOriginalFile,
  downloadOverviewReport,
  downloadReport,
  getRecordLimit
};